import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _pick from "lodash/pick";
const _excluded = ["sample_code", "solution"],
  _excluded2 = ["hint", "instructions"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/* eslint-disable camelcase */
import { load } from 'js-yaml';
import { MigrationResult } from './migration-result';
export const migrateV0ToV1 = data => {
  const baseData = _pick(data, ['title', 'xp', 'course_id', 'chapter_id', 'assignment', 'instructions', 'hint', 'sct', 'pre_exercise_code', 'language', 'runtime_config']);
  const sampleCode = data.sample_code === '' ? [] : load(data.sample_code);
  const solution = data.solution === '' ? [] : load(data.solution);
  return new MigrationResult('v1', _objectSpread(_objectSpread({}, baseData), {}, {
    sample_code: sampleCode,
    solution
  }));
};
export const migrateV1ToV2 = _ref => {
  let {
      sample_code,
      solution
    } = _ref,
    data = _objectWithoutProperties(_ref, _excluded);
  return new MigrationResult('v2', _objectSpread(_objectSpread({}, data), {}, {
    sampleCodeFiles: sample_code,
    solutionCodeFiles: solution
  }));
};
export const migrateV2ToV3 = _ref2 => {
  let {
      hint,
      instructions
    } = _ref2,
    data = _objectWithoutProperties(_ref2, _excluded2);
  return new MigrationResult('v3', _objectSpread(_objectSpread({}, data), {}, {
    instructionSteps: [{
      hint,
      instructions: instructions !== null && instructions !== void 0 ? instructions : ''
    }],
    solutionInstructions: ''
  }));
};
export const migrations = {
  v0: migrateV0ToV1,
  v1: migrateV1ToV2,
  v2: migrateV2ToV3
};
export default migrations;